import { Button } from "antd";
import { useNavigate } from "react-router";
import LockIcon from "../../assets/icons/lock.svg?react";

export default function Error403() {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center m-5 p-8 rounded-md bg-[#FFF]">
      <LockIcon />
      <div className="w-[25%] ml-[100px]">
        {/* <p className="text-[#06709B] text-[18px]">403 ERROR</p> */}
        <p className="text-[24px] mb-2">Access Denied</p>
        <p className="text-[#2B4752]">
          You do not have permissions to view this page until database lock.
          Please reach out to your administrator to update your permissions.
        </p>
        <Button
          onClick={() => navigate(-1)}
          variant="outlined"
          className="mt-3 w-[147px] bg-[#D2EFF9] text-[#064C68] border-[#064C68]"
        >
          Return
        </Button>
      </div>
    </div>
  );
}
